import { render, staticRenderFns } from "./ViewReceiveTransferInventory.vue?vue&type=template&id=9245471c"
import script from "./ViewReceiveTransferInventory.vue?vue&type=script&lang=js"
export * from "./ViewReceiveTransferInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports